/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ section: NonNullable<unknown> }} Layout_Header_Section_AttentionInputs */



/**
* | output |
* | --- |
* | "{section} needs your attention" |
*
* @param {Layout_Header_Section_AttentionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_section_attention = /** @type {((inputs: Layout_Header_Section_AttentionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Section_AttentionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.section} braucht deine Aufmerksamkeit`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.section} demande votre attention`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`${i?.section}需要你处理`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`${i?.section} 需要你處理`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`${i?.section}에 확인할 항목이 있습니다`)
	return /** @type {LocalizedString} */ (`${i?.section} needs your attention`)
});